/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scrape_Router_Per1kInputs */

const en_scrape_router_per1k = /** @type {(inputs: Scrape_Router_Per1kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price per 1,000 pages`)
};

const zh_hans1_scrape_router_per1k = /** @type {(inputs: Scrape_Router_Per1kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格按每 1,000 个页面计`)
};

const pt_br2_scrape_router_per1k = /** @type {(inputs: Scrape_Router_Per1kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço por mil páginas`)
};

const es_scrape_router_per1k = /** @type {(inputs: Scrape_Router_Per1kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio por cada 1,000 páginas`)
};

const fr_scrape_router_per1k = /** @type {(inputs: Scrape_Router_Per1kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix pour 1 000 pages`)
};

const de_scrape_router_per1k = /** @type {(inputs: Scrape_Router_Per1kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis pro 1.000 Seiten`)
};

const ru_scrape_router_per1k = /** @type {(inputs: Scrape_Router_Per1kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цена за 1000 страниц`)
};

const it_scrape_router_per1k = /** @type {(inputs: Scrape_Router_Per1kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo ogni 1.000 pagine`)
};

/**
* | output |
* | --- |
* | "Price per 1,000 pages" |
*
* @param {Scrape_Router_Per1kInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const scrape_router_per1k = /** @type {((inputs?: Scrape_Router_Per1kInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scrape_Router_Per1kInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_scrape_router_per1k(inputs)
	if (locale === "pt-BR") return pt_br2_scrape_router_per1k(inputs)
	if (locale === "es") return es_scrape_router_per1k(inputs)
	if (locale === "fr") return fr_scrape_router_per1k(inputs)
	if (locale === "de") return de_scrape_router_per1k(inputs)
	if (locale === "ru") return ru_scrape_router_per1k(inputs)
	if (locale === "it") return it_scrape_router_per1k(inputs)
	return en_scrape_router_per1k(inputs)
});